!customElements.get('product-form') &&
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.form.addEventListener('submit', this.handleSubmit.bind(this));
        this.formIdInput = this.form.querySelector('[name=id]');
        this.formIdInput.disabled = false;
        this.isMain = this.classList.contains('main-product-form');
        this.additionalAtcButtons = this.isMain
          ? document.querySelectorAll('.main-product-atc')
          : [];
        this.skipCart = this.formIdInput.dataset.skipCart === 'true';
        this.cart =
          document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        this.isCartUpsell = this.dataset.isCartUpsell === 'true';
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
          this.hasDrawer = true;
        }
        this.loadingSpinner = this.submitButton.querySelector('.loading-overlay__spinner');
        this.displayedSubmitButton = document.getElementById(
          `DisplayedSubmitBtn-${this.dataset.section}`,
        );
        this.bundleDeals = document.getElementById(`bundle-deals-${this.dataset.section}`);
        this.productInfo = document.getElementById(`ProductInfo-${this.dataset.section}`);
        this.quantityBreaks = document.getElementById(`quantity-breaks-${this.dataset.section}`);
        this.quantityPicker = document.getElementById(`Quantity-Form-${this.dataset.section}`);
        this.customFields = document.querySelectorAll(
          `[id^='CustomField-${this.dataset.section}-']`,
        );
        this.quantityGifts = document.getElementById(`quantity-gifts-${this.dataset.section}`);
        this.mainBundleItems = document.querySelectorAll(
          `.main-offer-item-${this.dataset.section}`,
        );
        this.variantInputs = this.form.querySelector('.product-form__variants');
      }
      handleSubmit(event) {
        let loadingButton = null,
          skipCartRedirect = false;
        if (event) {
          event.preventDefault();
          if (event.currentTarget.classList.contains('button--has-spinner')) {
            loadingButton = event.currentTarget;
            loadingButton.classList.add('loading');
          }
          if (event.currentTarget.dataset.skipCartButton === 'true') {
            skipCartRedirect = true;
          }
        }
        if (this.submitButton.getAttribute('aria-disabled') === 'true') {
          return;
        }
        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        if (!loadingButton) {
          this.submitButton.classList.add('loading');
          if (this.loadingSpinner) {
            this.loadingSpinner.classList.remove('hidden');
          }
        }
        this.additionalAtcButtons.forEach((button) => {
          button.setAttribute('disabled', '');
        });
        if (this.displayedSubmitButton) {
          this.displayedSubmitButton.setAttribute('disabled', '');
          this.displayedSubmitButton.classList.add('loading');
        }
        let requiresAdditionalProcessing = false;
        if (this.variantInputs && !this.ref) {
          this.variantInputs.innerHTML = '';
          let variantInputsHtml = '';
          let selectedItemIds = [];
          if (this.hasDrawer && !this.isCartUpsell && !this.skipCart) {
            this.cart
              .querySelectorAll("cart-drawer-upsell[data-toggle='true'], cart-drawer-gift")
              .forEach((item) => {
                if (
                  item.dataset.selected === 'true' &&
                  !this.cart.querySelector(`.cart-item--product-${item.dataset.handle}`)
                ) {
                  selectedItemIds.unshift(item.dataset.id);
                }
              });
          }
          if (this.bundleDeals) {
            requiresAdditionalProcessing = true;
            if (this.dataset.includePdpUpsells === 'true') {
              document.querySelectorAll('product-info-upsell').forEach((item) => {
                if (item.dataset.selected === 'true') {
                  selectedItemIds.unshift(item.dataset.id);
                }
              });
            }
            for (let i = 0; i < selectedItemIds.length; i++) {
              variantInputsHtml += `<input type="hidden" name="items[${i}][quantity]" value="1"><input type="hidden" name="items[${i}][id]" value="${selectedItemIds[i]}">`;
            }
            const offset = selectedItemIds.length;
            this.bundleDeals.formVariants.forEach((variant, index) => {
              variantInputsHtml += `<input type="hidden" name="items[${index + offset}][quantity]" value="${variant.quantity}"><input type="hidden" name="items[${index + offset}][id]" value="${variant.id}">`;
            });
            this.variantInputs.innerHTML = variantInputsHtml;
          } else {
            let quantityInputs = [];
            if (this.quantityGifts && this.quantityGifts.unlockedItems.length > 0) {
              selectedItemIds = [...selectedItemIds, ...this.quantityGifts.unlockedItems];
            }
            this.upsells = document.querySelectorAll(
              `.product-info-upsell-${this.dataset.section}`,
            );
            for (let i = this.upsells.length - 1; i >= 0; i--) {
              if (this.upsells[i].dataset.selected === 'true') {
                selectedItemIds.push(this.upsells[i].dataset.id);
              }
            }

            // Additional processing for mainBundleItems
            for (let i = this.mainBundleItems.length - 1; i >= 0; i--) {
              selectedItemIds.push(this.mainBundleItems[i].dataset.id);
            }
            if (selectedItemIds.length > 0) {
              requiresAdditionalProcessing = true;
              const groupedItems = [];
              selectedItemIds.forEach((id) => {
                const existingItemIndex = groupedItems.findIndex((item) => item.id === id);
                if (existingItemIndex === -1) {
                  groupedItems.push({
                    id,
                    quantity: 1,
                  });
                } else {
                  groupedItems[existingItemIndex].quantity += 1;
                }
              });
              groupedItems.forEach((item, index) => {
                variantInputsHtml += `<input type="hidden" name="items[${index}][quantity]" value="${item.quantity}"><input type="hidden" name="items[${index}][id]" value="${item.id}">`;
              });
              this.variantInputs.innerHTML = variantInputsHtml;
            }
          }
        }
        const fetchOptions = {
          ...fetchConfig('javascript'),
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
        };
        delete fetchOptions.headers['Content-Type'];
        const formData = new FormData(this.form);
        formData.append('sections', ['cart-drawer', 'cart-icon-bubble']);
        formData.append('sections_url', window.location.pathname);
        if (requiresAdditionalProcessing) {
          const options = this.dataset.options ? this.dataset.options.split(',') : [];
          const fieldsToRemove = ['id', 'quantity', ...options];
          fieldsToRemove.forEach((field) => {
            formData.delete(field);
          });
        }
        fetchOptions.body = formData;
        fetch(`${routes.cart_add_url}`, fetchOptions)
          .then((response) => response.json())
          .then((data) => {
            if (data.status) {
              this.handleErrorMessage(data.description);
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }
            if (this.skipCart || skipCartRedirect) {
              window.location = '/checkout';
              return;
            }
            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
              });
            }
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(data, this.isCartUpsell);
                  });
                },
                {
                  once: true,
                },
              );
              quickAddModal.hide(true);
            } else {
              //   this.cart.renderContents(data, this.isCartUpsell);
              // Always open cart
              this.cart.renderContents(data, false);
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            if (loadingButton) {
              loadingButton.classList.remove('loading');
            } else {
              this.submitButton.classList.remove('loading');
              if (this.loadingSpinner) {
                this.loadingSpinner.classList.add('hidden');
              }
            }
            this.additionalAtcButtons.forEach((button) => {
              button.removeAttribute('disabled');
            });
            if (this.displayedSubmitButton) {
              this.displayedSubmitButton.removeAttribute('disabled');
              this.displayedSubmitButton.classList.remove('loading');
            }
            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }
          });
      }
      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
!customElements.get('product-info') &&
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.deferredMedia = document.querySelector(`[${defMed}]`);
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');
        this.form = this.querySelector(`#ProductForm-${this.dataset.section}`);
        this.hasUrl = this.dataset.url !== null;
      }
      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;
      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this),
          );
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection
            ? this.dataset.originalSection
            : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
        if (!this.form) return;
        if (
          !this.deferredMedia ||
          !this.deferredMedia.src ||
          !this.deferredMedia.src.includes('net')
        ) {
          this.form.ref = true;
        }
      }
      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
      }
      setQuantityBoundries() {
        const quantityData = {
          cartQuantity: this.input.dataset.cartQuantity
            ? parseInt(this.input.dataset.cartQuantity)
            : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };
        let minValue = quantityData.min;
        const maxValue =
          quantityData.max === null
            ? quantityData.max
            : quantityData.max - quantityData.cartQuantity;
        if (maxValue !== null) {
          minValue = Math.min(minValue, maxValue);
        }
        if (quantityData.cartQuantity >= quantityData.min) {
          minValue = Math.min(minValue, quantityData.step);
        }
        this.input.min = minValue;
        this.input.max = maxValue;
        this.input.value = minValue;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }
      initShareLinks() {
        const shareButton = this.querySelector('.share-url-button');
        if (!shareButton) this.shareUrl = true;
      }
      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');
        fetch(
          `${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`,
        )
          .then((response) => response.text())
          .then((html) => {
            const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
            this.updateQuantityRules(this.dataset.section, parsedHtml);
            this.setQuantityBoundries();
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
          });
      }
      updateQuantityRules(sectionId, parsedHtml) {
        const quantityFormHtml = parsedHtml.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const currentElement = this.quantityForm.querySelector(selector);
          const newElement = quantityFormHtml.querySelector(selector);
          if (!currentElement || !newElement) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const value = newElement.getAttribute(attribute);
              if (value !== null) currentElement.setAttribute(attribute, value);
            }
          } else {
            currentElement.innerHTML = newElement.innerHTML;
          }
        }
      }
    },
  );
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', {
      bubbles: true,
    });
    this.quantityGifts = document.getElementById(`quantity-gifts-${this.dataset.section}`);
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this)),
    );
  }
  quantityUpdateUnsubscriber = undefined;
  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this),
    );
  }
  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }
  onInputChange(event) {
    this.validateQtyRules();
  }
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    if (event.target.name === 'plus') {
      this.input.stepUp();
    } else {
      this.input.stepDown();
    }
    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }
  }
  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const minusButton = this.querySelector(".quantity__button[name='minus']");
      minusButton.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const plusButton = this.querySelector(".quantity__button[name='plus']");
      plusButton.classList.toggle('disabled', value >= max);
    }
    if (this.quantityGifts && this.quantityGifts.unlockGifts) {
      this.quantityGifts.unlockGifts(value);
    }
  }
}
customElements.define('quantity-input', QuantityInput);
class QuantityBreaks extends HTMLElement {
  constructor() {
    (super(),
      (this.quantityGifts = document.getElementById('quantity-gifts-' + this.dataset.section)),
      (this.inputs = this.querySelectorAll('input[name="quantity"]')),
      (this.labels = this.querySelectorAll('.quantity-break')),
      (this.jsonData = this.querySelector('[type="application/json"]')),
      (this.hasVariants = this.jsonData.dataset.hasVariants === 'true'),
      (this.selectedVariants = {
        input_1: [],
        input_2: [],
        input_3: [],
        input_4: [],
        input_5: [],
        input_6: [],
      }),
      (this.updateUnavailable = this.dataset.updateUnavailable === 'true'),
      (this.skipNonExistent = this.dataset.skipNonExistent === 'true'),
      (this.skipUnavailable = this.dataset.skipUnavailable === 'true'),
      (this.formVariants = []),
      (this.selectedQuantity = 1));
    if (this.querySelector('input[checked]'))
      this.selectedQuantity = parseInt(this.querySelector('input[checked]').value);
    ((this.variantSelects = this.querySelectorAll('.quantity-break__selector-item')),
      (this.updatePrices = this.dataset.updatePrices === 'true'),
      (this.moneyFormat = this.dataset.moneyFormat));
    if (this.hasVariants) this.initVariants();
    (this.inputs.forEach((input) => {
      input.addEventListener('change', this.handleChange.bind(this));
    }),
      this.variantSelects.forEach((sel) => {
        sel.addEventListener('change', this.handleSelectChange.bind(this));
      }));
  }
  handleSelectChange(event) {
    const target = event.currentTarget,
      selectedValues = Array.from(target.querySelectorAll('select'), (s) => s.value);
    if (this.updateUnavailable) {
      const filteredVariants = this.getVariantData().filter(
          (v) => target.querySelector(':checked').value === v.option1,
        ),
        selects = [...target.querySelectorAll('.select--small')];
      updateVariantStatuses(filteredVariants, selects);
    }
    const variant = this.getVariantData().find((v2) => {
      return !v2.options
        .map((opt, idx) => {
          return selectedValues[idx] === opt;
        })
        .includes(false);
    });
    if (!variant) {
      if (this.skipNonExistent)
        findAvailableVariant(target, selectedValues, false, true, this.skipUnavailable);
      return;
    }
    if (this.skipUnavailable && !variant.available) {
      if (findAvailableVariant(target, selectedValues, false, true, true)) return;
    }
    target.dataset.selectedId = variant.id;
    const selectIndex = target.dataset.selectIndex,
      breakEl = target.closest('.quantity-break'),
      inputKey = breakEl.dataset.input;
    ((this.selectedVariants[inputKey][selectIndex] = variant.id),
      (this.formVariants = this.selectedVariants[inputKey]),
      this.updateMedia(variant));
    if (!this.updatePrices) return;
    let totalPrice = 0,
      totalCompare = 0;
    const quantity = parseFloat(breakEl.dataset.quantity),
      percentLeft = parseFloat(breakEl.dataset.percentageLeft),
      fixedDisc = parseFloat(breakEl.dataset.fixedDiscount);
    for (let i = 0; i < quantity; i++) {
      const variantId = parseInt(this.selectedVariants[inputKey][i]),
        variantData = this.getVariantData().find((v3) => parseInt(v3.id) === variantId);
      if (!variantData) return;
      ((totalPrice += variantData.price),
        variantData.compare_at_price && variantData.compare_at_price > variantData.price
          ? (totalCompare += variantData.compare_at_price)
          : (totalCompare += variantData.price));
    }
    totalPrice = totalPrice * percentLeft - fixedDisc;
    const savings = totalCompare - totalPrice,
      savingsRounded = Math.round(savings / 100) * 100,
      priceEach = totalPrice / quantity,
      compareEach = totalCompare / quantity,
      fmtPrice = formatMoney(totalPrice, this.moneyFormat, true),
      fmtCompare = formatMoney(totalCompare, this.moneyFormat, true),
      fmtSavings = formatMoney(savings, this.moneyFormat, true),
      fmtSavingsRnd = formatMoney(savingsRounded, this.moneyFormat, true),
      fmtPriceEach = formatMoney(priceEach, this.moneyFormat, true),
      fmtCompareEach = formatMoney(compareEach, this.moneyFormat, true);
    breakEl.querySelectorAll('.variant-price-update').forEach((priceUpdateEl) => {
      let text = priceUpdateEl.dataset.text;
      ((text = text.replace('[quantity]', quantity)),
        (text = text.replace('[price]', fmtPrice)),
        (text = text.replace('[compare_price]', fmtCompare)),
        (text = text.replace('[amount_saved]', fmtSavings)),
        (text = text.replace('[amount_saved_rounded]', fmtSavingsRnd)),
        (text = text.replace('[price_each]', fmtPriceEach)),
        (text = text.replace('[compare_price_each]', fmtCompareEach)),
        (priceUpdateEl.innerHTML = text));
    });
    const comparePriceEl = breakEl.querySelector('.quantity-break__compare-price');
    comparePriceEl &&
      (totalCompare > totalPrice
        ? comparePriceEl.classList.remove('hidden')
        : comparePriceEl.classList.add('hidden'));
  }
  getVariantData() {
    return (
      (this.variantData = this.variantData || JSON.parse(this.jsonData.textContent)),
      this.variantData
    );
  }
  initVariants() {
    if (!this.hasVariants) return;
    (this.labels.forEach((label) => {
      if (label.querySelector('.quantity-break__variants')) {
        let ids = [];
        (label.querySelectorAll('.quantity-break__selector-item').forEach((sel2) => {
          ids.push(sel2.dataset.selectedId);
        }),
          (this.selectedVariants[label.dataset.input] = ids));
      }
    }),
      (this.formVariants = []));
  }
  updateMedia(variant) {
    if (!variant) return;
    if (!variant.featured_media) return;
    const galleries = document.querySelectorAll(
      '[id^=\x22MediaGallery-' + this.dataset.section + '\x22]',
    );
    galleries.forEach((gallery) =>
      gallery.setActiveMedia(this.dataset.section + '-' + variant.featured_media.id, true),
    );
  }
  handleChange(event) {
    const quantity = parseInt(event.target.value);
    this.selectedQuantity = quantity;
    if (this.hasVariants) this.formVariants = this.selectedVariants[event.target.dataset.input];
    if (this.quantityGifts) this.quantityGifts.unlockGifts(quantity);
  }
}
customElements.define('quantity-breaks', QuantityBreaks);
class QuantityGifts extends HTMLElement {
  constructor() {
    (super(),
      (this.gifts = this.querySelectorAll('.quantity-gift')),
      (this.quantityBreaks = document.getElementById('quantity-breaks-' + this.dataset.section)),
      (this.quantitySelector = document.getElementById('Quantity-Form--' + this.dataset.section)),
      (this.unlockedItems = []),
      this.initUnlock());
  }
  initUnlock() {
    let quantity = 1;
    if (this.quantityBreaks) quantity = parseInt(this.quantityBreaks.selectedQuantity);
    else {
      if (this.quantitySelector) {
        const qtyInput = this.quantitySelector.querySelector('input[name="quantity"]');
        quantity = parseInt(qtyInput.value);
      }
    }
    this.unlockGifts(quantity);
  }
  unlockGifts(qty) {
    ((this.unlockedItems = []),
      this.gifts.forEach((gift) => {
        if (parseInt(gift.dataset.quantity) <= qty) {
          (gift.classList.add('quantity-gift--unlocked'), (gift.dataset.unlocked = 'true'));
          if (gift.dataset.product) this.unlockedItems.unshift(gift.dataset.product);
        } else
          (gift.classList.remove('quantity-gift--unlocked'), (gift.dataset.unlocked = 'false'));
      }));
  }
}
customElements.define('quantity-gifts', QuantityGifts);
class CustomProductField extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    ((this.fieldName = this.dataset.name),
      (this.input = this.querySelector('[type="text"], [type="number"], textarea')),
      (this.inputRadios = this.querySelectorAll('[type=\x22radio\x22]')),
      (this.select = this.querySelector('.select__select')),
      (this.productForm = document.getElementById('product-form-' + this.dataset.section)),
      (this.prevValue = this.dataset.defaultValue),
      (this.isRequired = this.dataset.required === 'true'),
      (this.isText = true),
      (this.notMain = this.dataset.notMain === 'true'));
    if (this.dataset.type === 'select' || this.dataset.type === 'pills') this.isText = false;
    this.createInputs();
    this.isRequired &&
      this.isText &&
      ((this.isValid = true),
      (this.atcButtons = this.notMain
        ? document.querySelectorAll('.featured-product-atc-' + this.dataset.section)
        : document.querySelectorAll('.main-product-atc')),
      (this.mainAtcButton = this.productForm.querySelector(
        '#ProductSubmitButton-' + this.dataset.section,
      )),
      (this.mainAtcBtnLabel = this.mainAtcButton.querySelector('.main-atc__label')),
      (this.mainAtcBtnError = this.mainAtcButton.querySelector('.main-atc__error')),
      (this.atcErrorMsg = this.dataset.atcErrorMsg),
      (this.mainAtcButton.dataset.requiredFields =
        parseInt(this.mainAtcButton.dataset.requiredFields) + 1),
      (this.mainAtcBtnError.innerHTML = this.atcErrorMsg),
      (this.applyStickyAtcError = this.dataset.applyStickyAtcError === 'true'),
      (this.stickyAtcButton = document.querySelector('#sticky-atc-' + this.dataset.section)),
      this.applyStickyAtcError &&
        this.stickyAtcButton &&
        ((this.stickyAtcBtnLabel = this.stickyAtcButton.querySelector('.sticky-atc__label')),
        (this.stickyAtcBtnError = this.stickyAtcButton.querySelector('.sticky-atc__error')),
        (this.stickyAtcBtnError.innerHTML = this.atcErrorMsg)),
      this.validateValue(this.prevValue, null));
    if (this.input) this.input.addEventListener('input', this.handleChange.bind(this));
    this.inputRadios.forEach((radio) => {
      radio.addEventListener('input', this.handleChange.bind(this));
    });
    if (this.select) this.select.addEventListener('change', this.handleChange.bind(this));
  }
  handleChange(event) {
    const val = event.target.value.trim();
    if (event.target.checkValidity()) this.prevValue = val;
    else {
      event.target.value = this.prevValue;
      return;
    }
    ((this.dataset.value = val), (this.productFormInput.value = val));
    if (this.isRequired && this.isText) this.validateValue(val, event.target);
  }
  validateValue(value, inputEl) {
    const isValid = value.length > 0 ? true : false;
    if (isValid === this.isValid) return;
    this.isValid = isValid;
    inputEl &&
      (this.isValid
        ? (inputEl.classList.remove('input--error'),
          (this.mainAtcButton.dataset.validFields =
            parseInt(this.mainAtcButton.dataset.validFields) + 1))
        : (inputEl.classList.add('input--error'),
          (this.mainAtcButton.dataset.validFields =
            parseInt(this.mainAtcButton.dataset.validFields) - 1)));
    const allValid =
        this.mainAtcButton.dataset.validFields === this.mainAtcButton.dataset.requiredFields,
      isUnavailable = this.mainAtcButton.dataset.unavailable === 'true';
    this.atcButtons.forEach((btn) => {
      allValid && !isUnavailable
        ? btn.removeAttribute('disabled')
        : btn.setAttribute('disabled', '');
    });
    if (this.atcErrorMsg.length === 0) return;
    allValid
      ? ((this.mainAtcBtnLabel.style.display = ''),
        (this.mainAtcBtnError.style.display = 'none'),
        this.applyStickyAtcError &&
          this.stickyAtcButton &&
          ((this.stickyAtcBtnLabel.style.display = ''),
          (this.stickyAtcBtnError.style.display = 'none')))
      : ((this.mainAtcBtnLabel.style.display = 'none'),
        (this.mainAtcBtnError.style.display = ''),
        this.applyStickyAtcError &&
          this.stickyAtcButton &&
          ((this.stickyAtcBtnLabel.style.display = 'none'),
          (this.stickyAtcBtnError.style.display = '')));
  }
  createInputs() {
    ((this.productFormInput = document.createElement('input')),
      this.productFormInput.setAttribute('type', 'hidden'),
      this.productFormInput.setAttribute('name', 'properties[' + this.fieldName + ']'),
      (this.productFormInput.value = this.dataset.defaultValue),
      this.productForm.appendChild(this.productFormInput));
  }
}
customElements.define('custom-product-field', CustomProductField);
class VariantSelects extends HTMLElement {
  constructor() {
    (super(),
      (this.secondarySelectSelector = 'StickyAtcVariantPicker-'),
      (this.secondarySelect = document.getElementById(
        '' + this.secondarySelectSelector + this.dataset.section,
      )),
      (this.isSecondary = false),
      (this.QuantityBreaks = document.getElementById('quantity-breaks-' + this.dataset.section)),
      (this.hasQuantityBreaksPicker = this.dataset.hasQuantityBreaksPicker === 'true'),
      (this.prependMedia = this.dataset.disablePrepend != 'true'),
      (this.filtering = this.dataset.hasFiltering === 'true'),
      (this.skipNonExistent = this.dataset.skipNonExistent === 'true'),
      (this.skipUnavailable = this.dataset.skipUnavailable === 'true'),
      this.hasQuantityBreaksPicker &&
        ((this.quantityBreaksPickerStyle = this.dataset.quantityBreaksPickerStyle),
        (this.quantityBreaksPickerDisplayedImages =
          this.dataset.quantityBreaksPickerDisplayedImages)),
      this.addEventListener('change', this.onVariantChange));
  }
  onVariantChange() {
    (this.updateOptions(),
      this.updateMasterId(),
      this.toggleAddButton(true, '', false),
      this.updatePickupAvailability(),
      this.removeErrorMessage(),
      this.updateVariantStatuses());
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      if (
        this.skipNonExistent &&
        findAvailableVariant(this, this.options, true, true, this.skipUnavailable)
      )
        return;
      this.setUnavailable();
    } else {
      if (this.skipUnavailable && !this.currentVariant.available) {
        if (findAvailableVariant(this, this.options, true, true, true)) return;
      }
      (this.updateMedia(),
        this.updateURL(),
        this.updateVariantInput(),
        this.renderProductInfo(),
        this.updateShareUrl());
    }
  }
  updateOptions() {
    const options = [];
    (this.querySelectorAll('.product-form__input').forEach((inputEl) => {
      let val;
      const inputType = inputEl.querySelector('.product-form__input__type').dataset.type;
      (inputType == 'dropdown' || inputType == 'dropdwon'
        ? (val = inputEl.querySelector('.select__select').value)
        : (val = inputEl.querySelector('input[type="radio"]:checked').value),
        options.push(val));
    }),
      (this.options = options));
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((v) => {
      return !v.options
        .map((opt, idx) => {
          return this.options[idx] === opt;
        })
        .includes(false);
    });
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const galleries = document.querySelectorAll(
      '[id^="MediaGallery-' + this.dataset.section + '\x22]',
    );
    galleries.forEach((gallery) =>
      gallery.setActiveMedia(
        this.dataset.section + '-' + this.currentVariant.featured_media.id,
        this.prependMedia,
        this.filtering,
        this.currentVariant,
      ),
    );
    const modalContent = document.querySelector(
      '#ProductModal-' + this.dataset.section + ' .product-media-modal__content',
    );
    if (!modalContent) return;
    const mediaItem = modalContent.querySelector(
      '[data-media-id="' + this.currentVariant.featured_media.id + '\x22]',
    );
    modalContent.prepend(mediaItem);
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', this.dataset.url + '?variant=' + this.currentVariant.id);
  }
  updateShareUrl() {
    const shareBtn = document.getElementById('Share-' + this.dataset.section);
    if (!shareBtn || !shareBtn.updateUrl) return;
    shareBtn.updateUrl(
      '' + window.shopUrl + this.dataset.url + '?variant=' + this.currentVariant.id,
    );
  }
  updateVariantInput() {
    const forms = document.querySelectorAll(
      '#product-form-' +
        this.dataset.section +
        ', #product-form-installment-' +
        this.dataset.section,
    );
    forms.forEach((form) => {
      const idInput = form.querySelector('input[name="id"]');
      ((idInput.value = this.currentVariant.id),
        idInput.dispatchEvent(
          new Event('change', {
            bubbles: true,
          }),
        ));
    });
  }
  updateVariantStatuses() {
    const filteredVariants = this.variantData.filter(
      (v) => this.querySelector(':checked').value === v.option1,
    );
    let inputEls;
    (this.isSecondary && this.secondarySelect
      ? (inputEls = [...this.secondarySelect.querySelectorAll('.product-form__input')])
      : (inputEls = [...this.querySelectorAll('.product-form__input')]),
      inputEls.forEach((inputEl2, optIdx) => {
        if (optIdx === 0) return;
        const inputs = [
            ...inputEl2.querySelectorAll('input[type="radio"], .select__select option'),
          ],
          prevVal = inputEls[optIdx - 1].querySelector(':checked').value,
          availVals = filteredVariants
            .filter((v2) => v2.available && v2['option' + optIdx] === prevVal)
            .map((v3) => v3['option' + (optIdx + 1)]),
          existVals = filteredVariants
            .filter((v4) => v4['option' + optIdx] === prevVal)
            .map((v5) => v5['option' + (optIdx + 1)]);
        this.setInputAvailability(inputs, availVals, existVals);
      }));
  }
  setInputAvailability(inputs2, available, existing) {
    inputs2.forEach((input) => {
      input.classList.remove('unavailable', 'non-existent', 'disabled');
      const value = input.getAttribute('value');
      let swatchEl = null;
      input.dataset.swatch === 'true' && (swatchEl = input.closest('.color-swatch'));
      if (swatchEl) swatchEl.classList.remove('unavailable', 'non-existent', 'disabled');
      if (existing.includes(value)) {
        if (available.includes(value)) {
          if (input.nodeName === 'OPTION') input.innerText = value;
          else {
            input.classList.remove('disabled');
            if (swatchEl) swatchEl.classList.remove('disabled');
          }
        } else {
          if (input.nodeName === 'OPTION')
            ((input.innerText = window.variantStrings.unavailable_with_option.replace(
              '[value]',
              value,
            )),
              input.classList.add('unavailable'));
          else {
            input.classList.add('disabled', 'unavailable');
            if (swatchEl) swatchEl.classList.add('disabled', 'unavailable');
          }
        }
      } else {
        if (input.nodeName === 'OPTION')
          ((input.innerText = window.variantStrings.unavailable_with_option.replace(
            '[value]',
            value,
          )),
            input.classList.add('non-existent'));
        else {
          input.classList.add('disabled', 'non-existent');
          if (swatchEl) swatchEl.classList.add('disabled', 'non-existent');
        }
      }
    });
  }
  updatePickupAvailability() {
    const pickupEl = document.querySelector('pickup-availability');
    if (!pickupEl) return;
    if (this.currentVariant && this.currentVariant.available) {
      if (pickupEl.fetchAvailability) pickupEl.fetchAvailability(this.currentVariant.id);
    } else (pickupEl.removeAttribute('available'), (pickupEl.innerHTML = ''));
  }
  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;
    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }
  renderProductInfo() {
    const variantId = this.currentVariant.id,
      sectionId = this.dataset.originalSection
        ? this.dataset.originalSection
        : this.dataset.section;
    fetch(
      this.dataset.url +
        '?variant=' +
        variantId +
        '&section_id=' +
        (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
    )
      .then((res) => res.text())
      .then((html) => {
        if (this.currentVariant.id !== variantId) return;
        const parsedDoc = new DOMParser().parseFromString(html, 'text/html'),
          priceEl = document.getElementById('price-' + this.dataset.section),
          newPriceEl = parsedDoc.getElementById(
            'price-' +
              (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
          ),
          sepPriceEl = document.getElementById('sticky-atc-separate-price-' + this.dataset.section),
          newSepPriceEl = parsedDoc.getElementById(
            'sticky-atc-separate-price-' +
              (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
          ),
          stickyPriceEl = document.getElementById('sticky-atc-price-' + this.dataset.section),
          newStickyPriceEl = parsedDoc.getElementById(
            'sticky-atc-price-' +
              (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
          ),
          stickyImgEl = document.getElementById('sticky-atc-image-' + this.dataset.section),
          newStickyImgEl = parsedDoc.getElementById(
            'sticky-atc-image-' +
              (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
          ),
          mainAtcPriceEl = document.getElementById('main-atc-price-' + this.dataset.section),
          newMainAtcPriceEl = parsedDoc.getElementById(
            'main-atc-price-' +
              (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
          ),
          customLabels = document.querySelectorAll(
            '[id^=\x22custom-label-' + this.dataset.section + '\x22]',
          ),
          newCustomLabels = parsedDoc.querySelectorAll(
            '[id^="custom-label-' +
              (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section) +
              '\x22]',
          ),
          newSkuEl = parsedDoc.getElementById(
            'Sku-' +
              (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
          ),
          skuEl = document.getElementById('Sku-' + this.dataset.section),
          newInventoryEl = parsedDoc.getElementById(
            'Inventory-' +
              (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
          ),
          inventoryEl = document.getElementById('Inventory-' + this.dataset.section);
        if (priceEl && newPriceEl) priceEl.innerHTML = newPriceEl.innerHTML;
        if (sepPriceEl && newSepPriceEl) sepPriceEl.innerHTML = newSepPriceEl.innerHTML;
        if (stickyPriceEl && newStickyPriceEl) stickyPriceEl.innerHTML = newStickyPriceEl.innerHTML;
        if (stickyImgEl && newStickyImgEl) stickyImgEl.src = newStickyImgEl.src;
        if (newMainAtcPriceEl && mainAtcPriceEl)
          mainAtcPriceEl.innerHTML = newMainAtcPriceEl.innerHTML;
        if (customLabels && newCustomLabels)
          for (let i = 0; i < customLabels.length; i++) {
            customLabels[i].innerHTML = newCustomLabels[i].innerHTML;
          }
        if (newInventoryEl && inventoryEl) inventoryEl.innerHTML = newInventoryEl.innerHTML;
        newSkuEl &&
          skuEl &&
          ((skuEl.innerHTML = newSkuEl.innerHTML),
          skuEl.classList.toggle(
            'visibility-hidden',
            newSkuEl.classList.contains('visibility-hidden'),
          ));
        if (this.QuantityBreaks) {
          const newQtyBreaks = parsedDoc.getElementById(
              'quantity-breaks-' +
                (this.dataset.originalSection
                  ? this.dataset.originalSection
                  : this.dataset.section),
            ),
            dynPrices = this.QuantityBreaks.querySelectorAll('.dynamic-price'),
            newDynPrices = newQtyBreaks.querySelectorAll('.dynamic-price');
          for (let j = 0; j < dynPrices.length; j++) {
            dynPrices[j].innerHTML = newDynPrices[j].innerHTML;
          }
          if (this.QuantityBreaks.hasVariants) {
            this.QuantityBreaks.variantSelects.forEach((sel) => {
              sel.dataset.selectedId = this.currentVariant.id;
            });
            const variantSels = this.QuantityBreaks.querySelectorAll(
                '.quantity-break__variant-select',
              ),
              newVariantSels = newQtyBreaks.querySelectorAll('.quantity-break__variant-select');
            for (let k = 0; k < variantSels.length; k++) {
              variantSels[k].innerHTML = newVariantSels[k].innerHTML;
            }
            this.QuantityBreaks.initVariants();
          }
        }
        if (this.hasQuantityBreaksPicker) {
          const newPicker = parsedDoc.getElementById(
              'variant-selects-' +
                (this.dataset.originalSection
                  ? this.dataset.originalSection
                  : this.dataset.section),
            ),
            dynPrices2 = this.querySelectorAll('.dynamic-price'),
            newDynPrices2 = newPicker.querySelectorAll('.dynamic-price');
          for (let l = 0; l < dynPrices2.length; l++) {
            dynPrices2[l].innerHTML = newDynPrices2[l].innerHTML;
          }
          if (
            this.quantityBreaksPickerStyle === 'vertical' &&
            this.quantityBreaksPickerDisplayedImages === 'variant_images'
          ) {
            const breakImgs = this.querySelectorAll('.quantity-break__image\x20img'),
              newBreakImgs = newPicker.querySelectorAll('.quantity-break__image\x20img');
            for (let m = 0; m < breakImgs.length; m++) {
              breakImgs[m].src = newBreakImgs[m].src;
            }
          }
        }
        if (this.secondarySelect) {
          const newSecondaryEl = parsedDoc.getElementById(
            '' +
              this.secondarySelectSelector +
              (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
          );
          if (newSecondaryEl) this.secondarySelect.innerHTML = newSecondaryEl.innerHTML;
        }
        const priceContainer = document.getElementById('price-' + this.dataset.section);
        if (priceContainer) priceContainer.classList.remove('visibility-hidden');
        this.dataset.options = this.currentVariant.options.join(',');
        if (inventoryEl)
          inventoryEl.classList.toggle('visibility-hidden', newInventoryEl.innerText === '');
        const submitBtn = parsedDoc.getElementById('ProductSubmitButton-' + sectionId);
        (this.toggleAddButton(
          submitBtn ? submitBtn.hasAttribute('disabled') : true,
          window.variantStrings.soldOut,
        ),
          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: sectionId,
              html: parsedDoc,
              variant: this.currentVariant,
            },
          }));
      });
  }
  toggleAddButton(disable = true, text, updateButtons = true) {
    const form = document.getElementById('product-form-' + this.dataset.section);
    if (!form) return;
    const atcBtn = form.querySelector('[name=\x22add\x22]'),
      mainAtcBtns = document.querySelectorAll('.main-product-atc');
    let labelEl = form.querySelector('.main-atc__label__text');
    if (!labelEl) labelEl = form.querySelector('.main-atc__label');
    const priceEl2 = form.querySelector('.main-atc-price');
    if (!atcBtn) return;
    if (disable) {
      (atcBtn.setAttribute('disabled', 'disabled'),
        atcBtn.setAttribute('data-unavailable', 'true'));
      if (text) labelEl.textContent = text;
      mainAtcBtns.forEach((btn) => {
        btn.setAttribute('disabled', 'disabled');
      });
      if (priceEl2) priceEl2.classList.add('hidden');
    } else {
      (atcBtn.setAttribute('data-unavailable', 'false'),
        (labelEl.textContent = window.variantStrings.addToCart));
      if (priceEl2) priceEl2.classList.remove('hidden');
      atcBtn.dataset.requiredFields === atcBtn.dataset.validFields &&
        (atcBtn.removeAttribute('disabled'),
        mainAtcBtns.forEach((btn2) => {
          btn2.removeAttribute('disabled');
        }));
    }
    if (!updateButtons) return;
  }
  setUnavailable() {
    const form2 = document.getElementById('product-form-' + this.dataset.section);
    if (!form2) return;
    const atcBtn = form2.querySelector('[name=\x22add\x22]');
    let labelEl = form2.querySelector('.main-atc__label__text');
    if (!labelEl) labelEl = form2.querySelector('.main-atc__label');
    const priceEl3 = document.getElementById('price-' + this.dataset.section),
      inventoryEl2 = document.getElementById('Inventory-' + this.dataset.section),
      skuEl = document.getElementById('Sku-' + this.dataset.section);
    if (!atcBtn) return;
    labelEl.textContent = window.variantStrings.unavailable;
    if (priceEl3) priceEl3.classList.add('visibility-hidden');
    if (inventoryEl2) inventoryEl2.classList.add('visibility-hidden');
    if (skuEl) skuEl.classList.add('visibility-hidden');
  }
  getVariantData() {
    return (
      (this.variantData =
        this.variantData ||
        JSON.parse(this.querySelector('[type="application/json"]').textContent)),
      this.variantData
    );
  }
}
customElements.define('variant-selects', VariantSelects);
class SecondaryVariantSelect extends VariantSelects {
  constructor() {
    (super(),
      (this.secondarySelectSelector = 'variant-selects-'),
      (this.secondarySelect = document.getElementById(
        '' + this.secondarySelectSelector + this.dataset.section,
      )),
      (this.isSecondary = true));
  }
  updateOptions() {
    this.options = this.querySelector('select').value.split(',');
  }
}
customElements.define('secondary-variant-select', SecondaryVariantSelect);
class SecondaryVariantSelectSeparate extends VariantSelects {
  constructor() {
    (super(),
      (this.secondarySelectSelector = 'variant-selects-'),
      (this.secondarySelect = document.getElementById(
        '' + this.secondarySelectSelector + this.dataset.section,
      )),
      (this.isSecondary = true));
  }
}
customElements.define('secondary-variant-select-separate', SecondaryVariantSelectSeparate);
class CardVariantSelects extends VariantSelects {
  constructor() {
    (super(), (this.quickAddSubmit = document.getElementById(this.dataset.section + '-submit')));
  }
  onVariantChange() {
    (this.updateOptions(),
      this.updateMasterId(),
      this.toggleAddButton(true, '', false),
      this.updateVariantStatuses(),
      !this.currentVariant
        ? (this.toggleAddButton(true, '', true), this.setUnavailable())
        : (this.updateMedia(),
          this.updateVariantInput(),
          this.updateQuickAddUrl(),
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut)));
  }
  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;
    const imageEl = document.getElementById(this.dataset.section + '-image');
    if (!imageEl) return;
    const previewImage = this.currentVariant.featured_media.preview_image,
      baseUrl = previewImage.src.split('?')[0],
      widths = [165, 360, 533, 720, 940, 1066],
      srcset = widths
        .filter((w) => previewImage.width >= w)
        .map((w2) => baseUrl + '?width=' + w2 + '\x20' + w2 + 'w')
        .join(',\x20');
    ((imageEl.srcset = srcset + ',\x20' + baseUrl + '\x20' + previewImage.width + 'w'),
      (imageEl.src = baseUrl + '?width=533'));
  }
  updateQuickAddUrl() {
    if (!this.currentVariant || !this.quickAddSubmit) return;
    this.quickAddSubmit.dataset.productUrl =
      this.dataset.url + '?variant=' + this.currentVariant.id;
  }
}
customElements.define('card-variant-selects', CardVariantSelects);
